import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import {
  FieldType,
  FormlyFieldConfig,
  FormlyFieldProps as CoreFormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';

interface TextAreaProps extends CoreFormlyFieldProps {
  placeholder?: string;
  rows?: number;
  cols?: number;
  autoResize?: boolean;
}

@Component({
  selector: 'formly-field-primeng-textarea',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    TextareaModule,
    InputTextModule,
  ],
  template: `
    <textarea
      [id]="id"
      [formControl]="textareaControl"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder || ''"
      [rows]="props.rows || 3"
      [cols]="props.cols"
      class="w-full p-2 border border-gray-300 rounded"
      [class.border-red-500]="showError">
    </textarea>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldTextArea extends FieldType<
  FormlyFieldConfig<TextAreaProps>
> {
  get textareaControl() {
    return this.formControl as FormControl;
  }
}
